import react, { Component } from 'react';
import { connect } from 'react-redux';
import Holder from 'react-holder-component';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';

import { fetchPosts } from '../actions/postActions';
import { fetchCarCats, fetchCarCat, fetchAllCars, fetchCars, fetchCar } from '../actions/carsActions';
import { fetchTehCats, fetchTehCat, fetchTehs, fetchTeh } from '../actions/tehActions';
import { fetchReviews } from '../actions/reviewActions';
import { fetchAdvantages } from '../actions/advantageActions';
import { fetchLogotypes } from '../actions/logotypesActions';

import { Container, Row, Col, Card, Form, ButtonGroup, Button, Image, Nav, Tab } from 'react-bootstrap';

import { FaCheck } from 'react-icons/fa';
import { BsBoxArrowInUpRight } from 'react-icons/bs';

// Swiper Slider
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';

class Index extends Component {
    componentDidMount() {
        this.props.fetchPosts()
        this.props.fetchAdvantages()
        this.props.fetchReviews()
        this.props.fetchLogotypes()
        this.props.fetchCarCats()
        this.props.fetchTehCats()
        this.props.fetchAllCars()
        // this.props.fetchCarCat()
        // this.props.fetchCars()
        // this.props.fetchCar()
        this.showroomItem = 2;
    }

    componentDidUpdate(type) {}   

    render() {
        const carcats = this.props.carcats.map(carcat => (
            <ButtonGroup key={carcat.id} size="sm" className="showroom-list-btngroup" vertical>
                <Button className="py-0 showroom-list-btn" onClick={() => this.props.fetchCars(carcat.id)}><Image src={`https://sinomost.kz${carcat.thumbnail}`} width="40px" /><br/>
                    <small>{carcat.title}</small>
                </Button>
            </ButtonGroup>
        ));
        const carcatslist = this.props.carcats.map(carcat => (
            <Col xs={6} md={4} key={carcat.id}>
                <Link href={() => window.location.href=`product/car/${carcat.id}`} className="px-0"><Image src={`https://sinomost.kz${carcat.thumbnail}`} width="80px" /><br/>{carcat.title}</Link>
            </Col>
        ));
        const carslist = this.props.cars.map(carcat => (
            <Col xs={6} md={4} key={carcat.id}>
                <Button variant="Link" href={`/product/car/${carcat.id}`} className="home-cats-button px-0"><Image src={`https://sinomost.kz${carcat.thumbnail}`} width="80px" /><br/>{carcat.title}</Button>
            </Col>
        ));
        const cars = this.props.cars.map(car => (
            <li key={car.id} className="mb-1">
                <h5 className="h6 w-100 float-left">{car.title}</h5><br/><small>Цена: {car.price_kzt}</small>
                <Button size="sm" className="float-right"
                    onClick={() => {
                        this.props.fetchCar(car.id);
                        this.showroomItem = 0;
                    }}>показать <BsBoxArrowInUpRight/></Button>
                <hr/>
            </li>
        ));
        const tehcats = this.props.tehcats.map(tehcat => (
            <>{tehcat.items>0 &&
                <ButtonGroup key={tehcat.id} size="sm" className="showroom-list-btngroup" vertical>
                    <Button className="py-0 px-1 showroom-list-btn" onClick={() => this.props.fetchTehs(tehcat.id)}><Image src={`https://sinomost.kz${tehcat.image}`} width="40px" /><br/>
                        <small>{tehcat.title}</small>
                    </Button>
                </ButtonGroup>
                }</>
        ));
        const tehcatslist = this.props.tehcats.map(tehcat => (
            <>{tehcat.items>0 &&
                <Col xs={6} md={4} key={tehcat.id} className="border-orange">
                    <Button variant="Link" href={`catalog/teh/${tehcat.id}`} className="home-cats-button px-0"><Image src={`https://sinomost.kz${tehcat.image}`} width="80px" /><br/>{tehcat.title}</Button>
                </Col>
                }</>
        ));
        const tehs = this.props.tehs.map(teh => (
            <li key={teh.id}>
                <h5 className="h6 w-100 float-left">{teh.title}</h5><br/><small>Цена: {teh.price_kzt}</small>
                <Button size="sm" className="float-right"
                    onClick={() => {
                        this.props.fetchTeh(teh.id);
                        this.showroomItem = 1;
                    }}>показать <BsBoxArrowInUpRight/></Button>
                <hr/>
            </li>
        ));

        const newsAndPosts = this.props.posts.slice(0, 4).map(post => (
            <Col xs={6} md={3} className="" style={{ width: '11rem' }} key={post.id}>
                <Image src={`https://sinomost.kz${post.thumbnail}`} width="100%" />
                <Card.Body className="text-left p-0">
                    <Card.Title className="h6">{post.title}</Card.Title>
                    <Card.Text><small>{post.short_description}</small></Card.Text>
                    <Button className="btn-orange">Подробнее</Button>
                </Card.Body>
            </Col>
        ));

        const advantages = this.props.advantages.map(advantage => (
            <Col xs={12} md={4}>
                <Card className="m-2 p-2" key={advantage.id}>
                    <Card.Header>
                        <Row>
                            <Col xs={3}><Image src={`https://sinomost.kz${advantage.image}`} width="100%"></Image></Col>
                            <Col>
                                <Card.Title>{advantage.name}</Card.Title>
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body>
                        <Card.Text>
                            {advantage.html}
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
        ));

        const reviews = this.props.reviews.slice(0, 3).map(review => (
            <Col xs={12} md={4}>
                <Card className="m-2 p-2" key={review.id}>
                    <Card.Header>
                        <Card.Title>{review.name}</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <Card.Text>
                            {review.review}
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
        ));


        const logotypes = (
            <Swiper slidesPerView={4} navigation autoplay={1} loop={true}>
                {this.props.logotypes.map(logotype => (
                    <SwiperSlide key={logotype.id}>
                        <Image src={`https://sinomost.kz${logotype.thumbnail}`} />
                    </SwiperSlide>
                ))}
            </Swiper>
        );




        return (
            <>
                <Helmet>
                    <meta charset="UTF-8" />
                    <title>Спецтехника и автомобили. Все виды. ТОО Синомост (Sinomost)</title>
                    <meta name="description" content="Фронтальные погразчики, самосвалы, автокраны, бульдозеры, экскаваторы, асфальтоукладчики, рейдеры. Кроссоверы, Седаны, Внедорожники." />
                    <meta name="keywords" content="Спецтехника, Фронтальные погразчики, самосвалы, автокраны, бульдозеры, экскаваторы, асфальтоукладчики, рейдеры. Кроссоверы, Седаны, Внедорожники" />
                </Helmet>
                <Container className="top-slider p-0" fluid>
                    <Swiper spaceBetween={0} slidesPerView={1} navigation autoplay={1} parallax loop
                        // onSlideChange={() => console.log('slide change')}
                        onSwiper={(swiper) => console.log(swiper)}>
                        <SwiperSlide className="double-slide slide-1">
                            <Row>
                                <Col sm={6} className="h-100">
                                    <div className="slide-overlay w-100">
                                        <video className="w-100" autoplay="autoplay" loop>
                                            <source src="https://sinomost.kz/media/videos/slider-2.mp4" type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video> 
                                    </div>
                                    <div className="slider-text-wrapper d-flex justify-content-start align-items-end">
                                        <h3 className="bg-line mx-auto ml-3 p-2">Автомобили будущего</h3>
                                    </div>
                                </Col>
                                <Col sm={6}>
                                    <div className="slide-overlay w-100">
                                        <video className="w-100" autoplay="autoplay" loop>
                                            <source src="https://sinomost.kz/media/videos/slider.mp4" type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video> 
                                    </div>
                                    <div className="slider-text-wrapper d-flex justify-content-end align-items-end">
                                        <h3 className="bg-line mx-auto mr-3 p-2">Спецтехника для любых задач</h3>
                                    </div>
                                </Col>
                            </Row>
                        </SwiperSlide>
                        <SwiperSlide className="single-slide slide-2">
                            <div className="slide-overlay w-100">
                            </div>
                            <div className="d-flex justify-content-end align-items-end">
                                <h3 className="h6 bg-line mx-auto mr-3 p-2">Все виды техники, в любых объемах, по самой выгодной для Вас цене!</h3>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide className="single-slide slide-3">
                            <div className="slide-overlay w-100">
                            </div>
                            <div className="d-flex justify-content-end align-items-end">
                                <h3 className="h6 bg-line mx-auto mr-3 p-2">Самые современные авто отвечающие высшим требованиям по качеству!</h3>
                            </div>
                        </SwiperSlide>
                        {/*<div className="swiper-overlay">
                THIS IS AN OVERLAY
            </div>*/}
                    </Swiper>
                </Container>
                <Container>
                    <Row className="mt-5">
                        <Col xs={12} md={6} className="pl-sm-0">
                            <h2 className="home-list-header bg-line">Автомобили</h2>
                            <Row className="mb-3 mx-0 home-list home-list-cars text-center custom-scroll">
                                {carslist}
                            </Row>
                        </Col>
                        <Col xs={12} md={6}>
                            <h2 className="home-list-header bg-line">Спец. Техника</h2>
                            <Row className="mb-3 mx-0 home-list home-list-tehs text-center custom-scroll">
                                {tehcatslist}
                            </Row>
                        </Col>
                    </Row>
                </Container>
                <Container className="my-3">
                    <Row>
                        <h2 className="home-list-header bg-line">Showroom</h2>
                    </Row>
                    <Row className="showroom">
                        <Tab.Container id="" defaultActiveKey="showroomDesc">
                            <Col sm={12} md={4} className="showroom-list p-0">
                                <Nav variant="tabs" activeKey="showroomNavCars" className="d-flex">
                                    <Nav.Item className="showroom-btn showroom-left-btn text-center w-50">
                                        <Nav.Link eventKey="showroomNavCars">
                                            <Image src="https://sinomost.kz/public/home/showroom-car.png" width="80px" />
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item className="showroom-btn showroom-right-btn text-center w-50">
                                        <Nav.Link eventKey="showroomNavTeh">
                                            <Image src="https://sinomost.kz/public/home/showroom-speceq.png" width="80px" />
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                                <Tab.Content className="pt-0">
                                    <Tab.Pane eventKey="showroomNavCars">
                                        <hr/>
                                        <h2>{this.props.carcat.title}</h2>
                                        <Nav className="flex-column">{cars}</Nav>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="showroomNavTeh">
                                        {tehcats}
                                        <hr/>
                                        <h2>{this.props.tehcat.title}</h2>
                                        <Nav className="flex-column">{tehs}</Nav>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                            <Col sm={12} md={8} className="px-0">
                                {this.showroomItem === 0 &&
                                <Card>
                                    <Tab.Container id="left-tabs-example" defaultActiveKey="showroomDesc">
                                        <Card.Header>
                                            <Card.Title><h2 className="h2 text-primary">{this.props.car.title}</h2></Card.Title>
                                            {this.props.car.other_images.length>0 ?
                                                <Swiper spaceBetween={0} slidesPerView={1} navigation controller={1} autoplay={1} parallax loop >
                                                    <SwiperSlide className="showroom-swiper">
                                                        <Card.Img variant="top" src={`${this.props.car.thumbnail}`} />
                                                    </SwiperSlide>
                                                    {this.props.car.other_images.map(image => (
                                                        <SwiperSlide key={image.id}>
                                                            <Card.Img variant="top" src={`${image.images}`} />
                                                        </SwiperSlide>
                                                    ))}
                                                </Swiper>
                                                :
                                                <Card.Img variant="top" src={`${this.props.car.thumbnail}`} />
                                            }
                                            <Button className="price-button">{this.props.car.price_kzt}</Button>
                                            {/*<Button className="call-button">Позвонить и узнать</Button>*/}
                                            {/*<ButtonGroup className="color-buttons">
                              {this.props.car.white && <span className="white"></span>}
                              {this.props.car.black && <span className="black"></span>}
                              {this.props.car.silver && <span className="silver"></span>}
                              {this.props.car.red && <span className="red"></span>}
                              {this.props.car.dark_red && <span className="dark_red"></span>}
                              {this.props.car.blue && <span className="blue"></span>}
                              {this.props.car.navy && <span className="navy"></span>}
                              {this.props.car.purple && <span className="purple"></span>}
                              {this.props.car.green && <span className="green"></span>}
                              {this.props.car.yellow && <span className="yellow"></span>}
                              {this.props.car.orange && <span className="orange"></span>}
                              {this.props.car.pink && <span className="pink"></span>}
                              {this.props.car.brown && <span className="brown"></span>}
                            </ButtonGroup>*/}
                                        </Card.Header>
                                        <Card.Body>
                                            <Nav variant="tabs">
                                                <Nav.Item>
                                                    <Nav.Link eventKey="showroomDesc">Описание</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="showroomChars">Характеристики</Nav.Link>
                                                </Nav.Item>
                                                {/*<Nav.Item>
                                                    <Nav.Link eventKey="showroomSpecs">Комплектации</Nav.Link>
                                                </Nav.Item>*/}
                                            </Nav>
                                            <Tab.Content>
                                                <Tab.Pane as="pre" eventKey="showroomDesc">
                                                    <div dangerouslySetInnerHTML={{ __html: this.props.car.description }} />
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="showroomChars">
                                                    <div dangerouslySetInnerHTML={{ __html: this.props.car.characteristics }} />
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="showroomSpecs">
                                                    {this.props.car.complectations.map(complectation => (
                                                        <Card.Text as="pre" key={complectation.id}>{complectation.title}</Card.Text>
                                                    ))}
                                                </Tab.Pane>
                                            </Tab.Content>
                                            <Button onClick={() => window.location.href=`product/car/${this.props.car.id}`}>Подробнее</Button>
                                        </Card.Body>
                                    </Tab.Container>
                                </Card>
                                }
                                {this.showroomItem === 1 &&
                                    <Card>
                                        <Tab.Container id="left-tabs-example" defaultActiveKey="showroomDesc">
                                            <Card.Header>
                                                <Card.Title><h2 className="h2 text-orange">{this.props.teh.title}</h2></Card.Title>
                                                {this.props.teh.other_images.length>0 ?
                                                    <Swiper spaceBetween={0} slidesPerView={1} navigation controller={1} autoplay={1} parallax loop
                                                        // onSlideChange={() => console.log('slide change')}
                                                        // onSwiper={(swiper) => console.log(swiper)}
                                                    >
                                                        <SwiperSlide className="showroom-swiper">
                                                            <Card.Img variant="top" src={`${this.props.teh.image}`} />
                                                        </SwiperSlide>
                                                        {this.props.teh.other_images.map(image => (
                                                            <SwiperSlide key={image.id}>
                                                                <Card.Img variant="top" src={`${image.images}`} />
                                                            </SwiperSlide>
                                                        ))}
                                                    </Swiper>
                                                    :
                                                    <Card.Img variant="top" src={`${this.props.teh.image}`} />
                                                }
                                                <Button className="price-button">{this.props.teh.price_kzt}</Button>
                                                {/*<Button className="call-button">Позвонить и узнать</Button>*/}
                                            </Card.Header>
                                            <Card.Body>
                                                <Nav variant="tabs">
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="showroomDesc">Описание</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="showroomChars">Характеристики</Nav.Link>
                                                    </Nav.Item>
                                                    {/*<Nav.Item>
                                                        <Nav.Link eventKey="showroomSpecs">Комплектации</Nav.Link>
                                                    </Nav.Item>*/}
                                                </Nav>
                                                <Tab.Content>
                                                    <Tab.Pane as="pre" eventKey="showroomDesc">
                                                        <div dangerouslySetInnerHTML={{ __html: this.props.teh.description }} />
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="showroomChars">
                                                        <div dangerouslySetInnerHTML={{ __html: this.props.teh.characteristics }} />
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="showroomSpecs">
                                                        {this.props.teh.complectations.map(complectation => (
                                                            <Card.Text as="pre" key={complectation.id}>{complectation.title}<br />
                                                                {complectation.length_width_heihgt_mm != null ? <>
                                                                    Габариты (ДxШxВ) {(complectation.length_width_heihgt_mm === '++') ? <FaCheck /> : `${complectation.length_width_heihgt_mm}` }; </> : <></>
                                                                }
                                                            </Card.Text>
                                                        ))}
                                                    </Tab.Pane>
                                                </Tab.Content>
                                                <Button onClick={() => window.location.href=`product/teh/${this.props.teh.id}`}>Подробнее</Button>
                                            </Card.Body>
                                        </Tab.Container>
                                    </Card>
                                }
                                {this.showroomItem === 2 &&
                                    <Card>
                                        <Card.Header>
                                            <Card.Img variant="top" src='https://sinomost.kz/media/logo.png'/>
                                        </Card.Header>
                                        <Card.Body>
                                            <Card.Title>Выберите позицию</Card.Title>
                                            <Button href="/catalog/car">Перейти в каталог авто</Button>
                                            <Button href="/catalog/teh">Перейти в каталог техники</Button>
                                        </Card.Body>
                                    </Card>
                                }
                            </Col>
                        </Tab.Container>
                    </Row>
                    <Row className="mt-5 text-center">
                        <Col xs={12}>
                            <h2 className="bg-line">Новости и статьи:</h2>
                        </Col>
                        {newsAndPosts}
                    </Row>
                    <Row className="mt-5 text-center">
                        <Col xs={12}>
                            <h2 className="bg-line">Преимущества покупки в Sinomost:</h2>
                        </Col>
                        <Col xs={12}>
                            <Row>
                                {advantages}
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <h2 className="bg-line">Мы на карте:</h2>
                        </Col>
                        <Col xs={12}>
                            <div className="w-100 p-0 m-0 mt-3"><div style={{ position: 'relative', overflow: 'hidden'}}><a href="https://yandex.kz/maps/162/almaty/?utm_medium=mapframe&utm_source=maps" style={{ color: '#eee', position: 'absolute', top: '0px'}}>Алматы</a><a href="https://yandex.kz/maps/162/almaty/?ll=76.831091%2C43.348340&utm_medium=mapframe&utm_source=maps&z=17" style={{color: '#eee', position: 'absolute', top: '14px'}}>Алматы — Яндекс Карты</a><iframe src="https://yandex.kz/map-widget/v1/?ll=76.831091%2C43.348340&z=17" width="100%" height="400" frameborder="1" allowfullscreen="true" style={{position: 'relative'}}></iframe></div></div>
                        </Col>
                    </Row>
                    {/*
          <Row className="mt-5 text-center">
            <Col xs={12}>
              <h2 className="bg-line">Отзывы о Sinomost:</h2>
            </Col>
            <Col xs={12}>
              <Row>
                {reviews}
              </Row>
            </Col>
            <Col xs={12}>
              <Button>Смотреть все</Button>
              <Button>Оставить отзыв</Button>
            </Col>
          </Row>
          <Row className="my-5 text-center">
            <Col xs={12} className="mb-3">
              <h2 className="bg-line">Наши партнеры:</h2>
            </Col>
            <Col xs={12}>
              {logotypes}
            </Col>
          </Row>
          */}
                </Container>
            </>
        );
    };
}

Index.propTypes = {
    /*  fetchPosts: PropTypes.func.isRequired,
  posts: PropTypes.array.isRequired,
  fetchReviews: PropTypes.func.isRequired,
  reviews: PropTypes.array.isRequired,
  fetchLogotypes: PropTypes.func.isRequired,
  logotypes: PropTypes.array.isRequired,
  fetchCarCats: PropTypes.array.isRequired,
  carCats: PropTypes.array.isRequired,
  fetchCarCat: PropTypes.array.isRequired,
  carCat: PropTypes.array.isRequired,
  fetchCars: PropTypes.array.isRequired,
  cars: PropTypes.array.isRequired,
  fetchCar: PropTypes.array.isRequired,
  car: PropTypes.array.isRequired,
  fetchTehCats: PropTypes.array.isRequired,
  tehCats: PropTypes.array.isRequired,
  fetchTehCat: PropTypes.array.isRequired,
  tehCat: PropTypes.array.isRequired,
  fetchTehs: PropTypes.array.isRequired,
  tehs: PropTypes.array.isRequired,
  fetchTeh: PropTypes.array.isRequired,
  teh: PropTypes.array.isRequired,*/
}

const mapStateToProps = state => ({
    posts: state.posts.items,
    advantages: state.advantages.items,
    reviews: state.reviews.items,
    logotypes: state.logotypes.items,
    carcats: state.cars.carcats,
    carcat: state.cars.carcat,
    cars: state.cars.cars,
    car: state.cars.car,
    tehcats: state.teh.tehcats,
    tehcat: state.teh.tehcat,
    tehs: state.teh.tehs,
    teh: state.teh.teh,
});

export default connect(mapStateToProps, { fetchPosts, fetchAdvantages, fetchReviews, fetchLogotypes, fetchCarCats, fetchCarCat, fetchAllCars, fetchCars, fetchCar, fetchTehCats, fetchTehCat, fetchTehs, fetchTeh })(Index);
